<template>
    <a-row class="vh-100" type="flex" align="middle" justify="center">
        <a-col :xs="24" :sm="24" :md="6" :lg="6">
            <a-card>
                <a-form class="login-form" @submit.prevent="setPassword({ user, token })">
                    <a-form-item
                        :label="lang.password.password_label"
                        :validate-status="hasError('password') ? 'error' : ''"
                        :has-feedback="true"
                        :help="getError('password')">
                            <a-input-password
                                id="password"
                                v-model="user.password"
                                :placeholder="lang.password.password_placeholder"
                                @keyup="removeError('password')">
                                <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                            </a-input-password>
                    </a-form-item>
                    <a-form-item class="text-center">
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="isLoading"
                            class="login-form-button"
                            block>
                                {{ lang.password.send }}
                        </a-button>
                    </a-form-item>
                    <a-form-item class="text-center">
                        <router-link type="link" to="/login" class="login-form-button" block>
                            {{ lang.password.go_login }}
                        </router-link>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-col>
    </a-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    data: () => ({
        token: '',
        user: {
            password: '',
        }
    }),
    computed: {
        ...mapGetters({
            lang: 'lang',
            hasError: 'hasError',
            getError: 'getError'
        }),
        ...mapState({
            isLoading: state => state.session.isLoading
        })
    },
    methods: {
        ...mapActions({
            setPassword: 'session/setPassword',
            removeError: 'removeError'
        }),
    },
    mounted () {
        let token = this.$route.query.t;
        if (!token) {
            this.$router.push({ name: 'login' })
        } else {
            this.token = token
        }
    }
}
</script>